import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/disk/external_accounts.svg';
const ExternalAccount = () => React.createElement(IconSvg, null);
export default ExternalAccount;
